/* Cores padrão compartilhadas entre os sidebars */
export const SIDEBAR_ICON_COLOR = '#546e7a';
export const SIDEBAR_TEXT_COLOR = '#3c4345';

/* Monta a árvore de itens, aplicando permissão */
export function buildMenuTree(items, hasPerm) {
    return (items || []).map((item) => {
        const hasChildren = !!(item.children && item.children.length > 0);

        if (!hasChildren) {
            const allowed = !item.permCode || Number(item.permCode) === 0 || hasPerm(item.permCode);

            return {
                ...item,
                visible: item.visible !== false,
                disabled: !allowed,
                children: []
            };
        }

        return {
            ...item,
            visible: item.visible !== false,
            disabled: false,
            children: buildMenuTree(item.children, hasPerm)
        };
    });
};

/* Rótulo do item */
export function getItemLabel(item) {
    return (item.fallbackLabel || item.label || item.title || item.name || '');
};

/* Pathname do item (aceita string ou objeto de location) */
export function getPathname(to) {
    if (typeof to === 'string') {
        return to;
    }

    if (to && typeof to === 'object') {
        return to.pathname || '';
    }

    return '';
};

/* Verifica se a rota é ativa */
export function isCurrentRoute(locationPathname, itemTo) {
    const itemPathname = getPathname(itemTo);

    if (!itemPathname) {
        return false;
    }

    return locationPathname === itemPathname;
};

/* Verifica se a rota atual está dentro do item (destaca o menu pai) */
export function hasActiveDescendant(item, pathname) {
    if (!item.children || item.children.length === 0) {
        return isCurrentRoute(pathname, item.to);
    }

    return item.children.some((child) => hasActiveDescendant(child, pathname));
};

/* Retorna as keys ancestrais até o item alvo */
export function findAncestorKeys(items, targetKey, ancestors = []) {
    for (const currentItem of items) {
        if (currentItem.key === targetKey) {
            return ancestors;
        }

        if (currentItem.children && currentItem.children.length > 0) {
            const result = findAncestorKeys(
                currentItem.children,
                targetKey,
                [...ancestors, currentItem.key]
            );

            if (result) return result;
        }
    }

    return null;
};

/* Retorna todas as keys descendentes do item */
export function getDescendantKeys(item) {
    if (!item?.children || item.children.length === 0) return [];

    return item.children.reduce((acc, child) => {
        acc.push(child.key);
        return [...acc, ...getDescendantKeys(child)];
    }, []);
};